/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{disposeMaybe as s}from"../../core/maybe.js";class t{constructor(){this._result=!1}dispose(){this._program=s(this._program)}get result(){return null!=this._program&&(this._result=this._test(this._program),this.dispose()),this._result}}export{t as WebGLDriverTestModule};
